module.exports = __webpack_public_path__ + "static/scale-model-of-nashville-tennessee-2925ddbcdc75c3302515b0ce3c3685c8.png";